import { z } from 'zod';

import { swEnvSchema } from './swEnvSchema';

export const nextJsEnvSchema = {
  client: {
    NEXT_PUBLIC_ACADEMIC_YEAR_START_DAY: z.coerce.number().default(1),
    NEXT_PUBLIC_ACADEMIC_YEAR_START_MONTH: z.coerce.number().default(9),
    NEXT_PUBLIC_ACCOUNT_PROFILE_ADDRESS: z
      .string()
      .url()
      .default('https://myaccount.governorhub.com'),
    NEXT_PUBLIC_ADMIN_URL: z
      .string()
      .url()
      .default('https://admin.governorhub.com'),
    NEXT_PUBLIC_APOLLO_MAX_ATTEMPTS: z.coerce.number().default(5),
    NEXT_PUBLIC_APP_URL: z.string().url().default('http://localhost:3000'),
    NEXT_PUBLIC_AWS_CERTIFICATE_UPLOAD_ACCESS_KEY: z.string(),
    NEXT_PUBLIC_AWS_FILE_UPLOAD_ACCESS_KEY: z.string(),
    NEXT_PUBLIC_AWS_IMAGE_UPLOAD_ACCESS_KEY: z.string(),
    NEXT_PUBLIC_CERTIFICATE_UPLOAD_BUCKET: z
      .string()
      .default('ortoo-certificates-2'),
    NEXT_PUBLIC_CERTIFICATE_UPLOAD_URL: z
      .string()
      .url()
      .default('https://certificates.governorhub.com'),
    NEXT_PUBLIC_CLIENT_NAME: z.string().default('governorhub'),
    NEXT_PUBLIC_CURRENT_LOGO_PATH: z
      .string()
      .default('https://logos.governorhub.com/current'),
    NEXT_PUBLIC_DEFAULT_TERM_OF_OFFICE_YEARS: z.coerce.number().default(4),
    NEXT_PUBLIC_DEV_VM: z
      .union([z.literal('true'), z.literal('false')])
      .default('false')
      .transform((value) => value === 'true'),
    NEXT_PUBLIC_FILE_UPLOAD_BUCKET: z
      .string()
      .default('governorhub-file-storage'),
    NEXT_PUBLIC_FILE_UPLOAD_URL: z
      .string()
      .url()
      .default('https://docs.governorhub.com'),
    NEXT_PUBLIC_GRAPHQL_API_ENDPOINT: z
      .string()
      .default('http://localhost:3000/api/graphql'),
    NEXT_PUBLIC_GRAPHQL_WS_API_ENDPOINT: z
      .string()
      .default('ws://localhost:3000/api/graphql'),
    NEXT_PUBLIC_GOVERNORHUB_KNOWLEDGE_TRAINING_PROVIDER: z
      .string()
      .default('631b57ec8e13ba17fa78b218'),
    NEXT_PUBLIC_GOVERNORHUB_KNOWLEDGE_URL: z
      .string()
      .url()
      .default('https://schoolgovernors.thekeysupport.com'),
    NEXT_PUBLIC_HELP_URL: z
      .string()
      .url()
      .default('https://help.governorhub.com'),
    NEXT_PUBLIC_IMAGE_UPLOAD_BUCKET: z.string(),
    NEXT_PUBLIC_IMAGE_UPLOAD_URL: z
      .string()
      .url()
      .default('https://images.governorhub.com'),
    NEXT_PUBLIC_IMGIX_CDN_SOURCE: z.string().default('governorhub-assets'),
    NEXT_PUBLIC_INTERCOM_APP_ID: z.string().default('zcj9va1l'),
    NEXT_PUBLIC_INTERNAL_TRAINING_PROVIDER: z
      .string()
      .default('5dd533b09ffbaf5ee1807a15'),
    NEXT_PUBLIC_KEY_GOVERNANCE_URL: z
      .string()
      .url()
      .default('https://schoolgovernors.thekeysupport.com'),
    NEXT_PUBLIC_KEY_GOVERNANCE_REDIRECT_URL: z
      .string()
      .url()
      .default(
        'https://schoolgovernors.thekeysupport.com/?origin=governorhub&sync=true',
      ),
    NEXT_PUBLIC_KSG_LEARNING_PATHWAY_REDIRECT_URL: z
      .string()
      .url()
      .default(
        'https://schoolgovernors.thekeysupport.com/learning_pathway/scorm-redirect/',
      ),
    NEXT_PUBLIC_OSANO_CONFIG_ID: z
      .string()
      .default('dd1aa37c-83e3-4116-ad34-5a1efdc57783'),
    NEXT_PUBLIC_OSANO_CUSTOMER_ID: z.string().default('16A1EUSBcAwTb1fxu'),
    NEXT_PUBLIC_OSANO_ENABLED: z
      .enum(['true', 'false'])
      .default('false')
      .transform((value) => value === 'true'),
    NEXT_PUBLIC_NODE_ENV: z.union([
      z.literal('development'),
      z.literal('production'),
    ]),
    NEXT_PUBLIC_PUSHER_KEY: z.string(),
    NEXT_PUBLIC_DEFAULT_REST_API_ENDPOINT: z
      .string()
      .url()
      .default('https://app.governorhub.com/api/v2'),
    NEXT_PUBLIC_REST_API_ENDPOINT: z
      .string()
      .default('http://localhost:3000/api/v2'),
    NEXT_PUBLIC_SITE_NAME: z.string().default('GovernorHub'),
    NEXT_PUBLIC_TIMEZONE: z.string().default('Europe/London'),
    NEXT_PUBLIC_GA_TRACKING_ID: z.string().default('G-51D691JCP3'),
    NEXT_PUBLIC_NORFOLK_TRAINING_PROVIDER: z
      .string()
      .default('66a0fc9b6a29b52ce3cfaca8'),
    NEXT_PUBLIC_IMPERSONATION_COOKIE_NAME: z
      .string()
      .default('gh_impersonation'),
    NEXT_PUBLIC_USER_ID_COOKIE_NAME: z.string().default('gh_user_id'),
    NEXT_PUBLIC_SUPERUSER_COOKIE_NAME: z.string().default('gh_superuser'),
    NEXT_PUBLIC_ANALYTICS_COLLECTION_API_KEY: z.string(),
    NEXT_PUBLIC_SUPPORT_EMAIL: z.string().default('support@governorhub.com'),
    NEXT_PUBLIC_STAR_ACADEMIES_TRAINING_PROVIDER: z
      .string()
      .default('67a346e1bcf644c7d75f8709'),
    NEXT_PUBLIC_S3_BASE_URL_ORTOO_IMAGES: z
      .string()
      .url()
      .default('https://ortoo-images.s3.eu-west-1.amazonaws.com'),
    NEXT_PUBLIC_S3_BASE_URL_ASSETS: z
      .string()
      .url()
      .default(
        'https://s3.eu-west-1.amazonaws.com/static.governorhub.com/assets',
      ),
    ...swEnvSchema.client,
    NEXT_PUBLIC_FIREBASE_VAPID_KEY: z.string(),
    NEXT_PUBLIC_MUI_X_LICENSE_KEY: z.string(),
    NEXT_PUBLIC_POSTHOG_KEY: z.string().optional(),
    NEXT_PUBLIC_POSTHOG_HOST: z
      .string()
      .url()
      .default('https://eu.i.posthog.com'),
  },
  server: {
    GRAPHQL_API_ENDPOINT: z
      .string()
      .default('http://localhost:3000/api/graphql'),
  },
  experimental__runtimeEnv: {
    NEXT_PUBLIC_ACADEMIC_YEAR_START_DAY:
      process.env.NEXT_PUBLIC_ACADEMIC_YEAR_START_DAY,
    NEXT_PUBLIC_ACADEMIC_YEAR_START_MONTH:
      process.env.NEXT_PUBLIC_ACADEMIC_YEAR_START_MONTH,
    NEXT_PUBLIC_ACCOUNT_PROFILE_ADDRESS:
      process.env.NEXT_PUBLIC_ACCOUNT_PROFILE_ADDRESS,
    NEXT_PUBLIC_ADMIN_URL: process.env.NEXT_PUBLIC_ADMIN_URL,
    NEXT_PUBLIC_APOLLO_MAX_ATTEMPTS:
      process.env.NEXT_PUBLIC_APOLLO_MAX_ATTEMPTS,
    NEXT_PUBLIC_APP_URL: process.env.NEXT_PUBLIC_APP_URL,
    NEXT_PUBLIC_AWS_CERTIFICATE_UPLOAD_ACCESS_KEY:
      process.env.NEXT_PUBLIC_AWS_CERTIFICATE_UPLOAD_ACCESS_KEY,
    NEXT_PUBLIC_AWS_FILE_UPLOAD_ACCESS_KEY:
      process.env.NEXT_PUBLIC_AWS_FILE_UPLOAD_ACCESS_KEY,
    NEXT_PUBLIC_AWS_IMAGE_UPLOAD_ACCESS_KEY:
      process.env.NEXT_PUBLIC_AWS_IMAGE_UPLOAD_ACCESS_KEY,
    NEXT_PUBLIC_CERTIFICATE_UPLOAD_BUCKET:
      process.env.NEXT_PUBLIC_CERTIFICATE_UPLOAD_BUCKET,
    NEXT_PUBLIC_CERTIFICATE_UPLOAD_URL:
      process.env.NEXT_PUBLIC_CERTIFICATE_UPLOAD_URL,
    NEXT_PUBLIC_CLIENT_NAME: process.env.NEXT_PUBLIC_CLIENT_NAME,
    NEXT_PUBLIC_CURRENT_LOGO_PATH: process.env.NEXT_PUBLIC_CURRENT_LOGO_PATH,
    NEXT_PUBLIC_DEFAULT_TERM_OF_OFFICE_YEARS:
      process.env.NEXT_PUBLIC_DEFAULT_TERM_OF_OFFICE_YEARS,
    NEXT_PUBLIC_DEV_VM: process.env.NEXT_PUBLIC_DEV_VM,
    NEXT_PUBLIC_GOVERNORHUB_KNOWLEDGE_TRAINING_PROVIDER:
      process.env.NEXT_PUBLIC_GOVERNORHUB_KNOWLEDGE_TRAINING_PROVIDER,
    NEXT_PUBLIC_FILE_UPLOAD_BUCKET: process.env.NEXT_PUBLIC_FILE_UPLOAD_BUCKET,
    NEXT_PUBLIC_FILE_UPLOAD_URL: process.env.NEXT_PUBLIC_FILE_UPLOAD_URL,
    NEXT_PUBLIC_GRAPHQL_API_ENDPOINT:
      process.env.NEXT_PUBLIC_GRAPHQL_API_ENDPOINT,
    NEXT_PUBLIC_GRAPHQL_WS_API_ENDPOINT:
      process.env.NEXT_PUBLIC_GRAPHQL_WS_API_ENDPOINT,
    NEXT_PUBLIC_GOVERNORHUB_KNOWLEDGE_URL:
      process.env.NEXT_PUBLIC_GOVERNORHUB_KNOWLEDGE_URL,
    NEXT_PUBLIC_HELP_URL: process.env.NEXT_PUBLIC_HELP_URL,
    NEXT_PUBLIC_IMAGE_UPLOAD_BUCKET:
      process.env.NEXT_PUBLIC_IMAGE_UPLOAD_BUCKET,
    NEXT_PUBLIC_IMAGE_UPLOAD_URL: process.env.NEXT_PUBLIC_IMAGE_UPLOAD_URL,
    NEXT_PUBLIC_IMGIX_CDN_SOURCE: process.env.NEXT_PUBLIC_IMGIX_CDN_SOURCE,
    NEXT_PUBLIC_INTERCOM_APP_ID: process.env.NEXT_PUBLIC_INTERCOM_APP_ID,
    NEXT_PUBLIC_INTERNAL_TRAINING_PROVIDER:
      process.env.NEXT_PUBLIC_INTERNAL_TRAINING_PROVIDER,
    NEXT_PUBLIC_KEY_GOVERNANCE_URL: process.env.NEXT_PUBLIC_KEY_GOVERNANCE_URL,
    NEXT_PUBLIC_KEY_GOVERNANCE_REDIRECT_URL:
      process.env.NEXT_PUBLIC_KEY_GOVERNANCE_REDIRECT_URL,
    NEXT_PUBLIC_KSG_LEARNING_PATHWAY_REDIRECT_URL:
      process.env.NEXT_PUBLIC_KSG_LEARNING_PATHWAY_REDIRECT_URL,
    NEXT_PUBLIC_OSANO_CONFIG_ID: process.env.NEXT_PUBLIC_OSANO_CONFIG_ID,
    NEXT_PUBLIC_OSANO_CUSTOMER_ID: process.env.NEXT_PUBLIC_OSANO_CUSTOMER_ID,
    NEXT_PUBLIC_OSANO_ENABLED: process.env.NEXT_PUBLIC_OSANO_ENABLED,
    NEXT_PUBLIC_NODE_ENV: process.env.NEXT_PUBLIC_NODE_ENV,
    NEXT_PUBLIC_PUSHER_KEY: process.env.NEXT_PUBLIC_PUSHER_KEY,
    NEXT_PUBLIC_DEFAULT_REST_API_ENDPOINT:
      process.env.NEXT_PUBLIC_DEFAULT_REST_API_ENDPOINT,
    NEXT_PUBLIC_REST_API_ENDPOINT: process.env.NEXT_PUBLIC_REST_API_ENDPOINT,
    NEXT_PUBLIC_SITE_NAME: process.env.NEXT_PUBLIC_SITE_NAME,
    NEXT_PUBLIC_TIMEZONE: process.env.NEXT_PUBLIC_TIMEZONE,
    NEXT_PUBLIC_GA_TRACKING_ID: process.env.NEXT_PUBLIC_GA_TRACKING_ID,
    NEXT_PUBLIC_NORFOLK_TRAINING_PROVIDER:
      process.env.NEXT_PUBLIC_NORFOLK_TRAINING_PROVIDER,
    NEXT_PUBLIC_IMPERSONATION_COOKIE_NAME:
      process.env.NEXT_PUBLIC_IMPERSONATION_COOKIE_NAME,
    NEXT_PUBLIC_USER_ID_COOKIE_NAME:
      process.env.NEXT_PUBLIC_USER_ID_COOKIE_NAME,
    NEXT_PUBLIC_SUPERUSER_COOKIE_NAME:
      process.env.NEXT_PUBLIC_SUPERUSER_COOKIE_NAME,
    NEXT_PUBLIC_ANALYTICS_COLLECTION_API_KEY:
      process.env.NEXT_PUBLIC_ANALYTICS_COLLECTION_API_KEY,
    NEXT_PUBLIC_SUPPORT_EMAIL: process.env.NEXT_PUBLIC_SUPPORT_EMAIL,
    NEXT_PUBLIC_STAR_ACADEMIES_TRAINING_PROVIDER:
      process.env.NEXT_PUBLIC_STAR_ACADEMIES_TRAINING_PROVIDER,
    NEXT_PUBLIC_S3_BASE_URL_ORTOO_IMAGES:
      process.env.NEXT_PUBLIC_S3_BASE_URL_ORTOO_IMAGES,
    NEXT_PUBLIC_S3_BASE_URL_ASSETS: process.env.NEXT_PUBLIC_S3_BASE_URL_ASSETS,
    NEXT_PUBLIC_FIREBASE_API_KEY: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
    NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID:
      process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
    NEXT_PUBLIC_FIREBASE_VAPID_KEY: process.env.NEXT_PUBLIC_FIREBASE_VAPID_KEY,
    NEXT_PUBLIC_FIREBASE_PROJECT_ID:
      process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
    NEXT_PUBLIC_FIREBASE_APP_ID: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
    NEXT_PUBLIC_MUI_X_LICENSE_KEY: process.env.NEXT_PUBLIC_MUI_X_LICENSE_KEY,
    NEXT_PUBLIC_POSTHOG_KEY: process.env.NEXT_PUBLIC_POSTHOG_KEY,
    NEXT_PUBLIC_POSTHOG_HOST: process.env.NEXT_PUBLIC_POSTHOG_HOST,
  },
};
